// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';
import BiasPage from './pages/BiasPage';
import TrendsPage from './pages/TrendsPage'
import TriggersPage from './pages/TriggersPage';
import HomePage from './pages/Home';
import Callback from './pages/Callback';
import TrendDetailPage from './pages/TrendDetailPage';
import TriggerDetailPage from './pages/TriggerDetailPage';
import BiasDetailPage from './pages/BiasDetailPage';
import { useAuth0 } from '@auth0/auth0-react';
import LoginPage from './pages/Login';
import CornerToCornerPage from './pages/CornerToCornerPage';
import CornerToCornerDetailPage from './pages/CornerToCornetDetailPage';

function App() {
  const { isAuthenticated, loginWithRedirect, logout, user, isLoading } = useAuth0();

  return (
    <Router>
      <div className="min-h-screen bg-gray-100">
        {/* Navigation */}
        <nav className="bg-white shadow-lg">
          <div className="max-w-7xl mx-auto px-4">
            <div className="flex justify-between h-16 items-center">
              <div className="flex">
                <div className="flex-shrink-0 flex items-center">
                  <h1 className="text-xl font-bold text-gray-800">Backoffice</h1>
                </div>
                <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
                  <Link
                    to="/"
                    className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                  >
                    Home
                  </Link>
                  <Link
                    to="/bias"
                    className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                  >
                    Bias
                  </Link>
                  <Link
                    to="/trends"
                    className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                  >
                    Trends
                  </Link>
                  <Link
                    to="/triggers"
                    className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                  >
                    Triggers
                  </Link>
                  <Link
                    to="/corner-to-corner"
                    className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                  >
                    Corner To Corner
                  </Link>
                </div>
              </div>

              {/* Auth buttons */}
              <div className="flex items-center space-x-4">
                {isLoading ? (
                  <span className="text-gray-500 text-sm">Loading...</span>
                ) : isAuthenticated ? (
                  <>
                    <span className="text-gray-600 text-sm">{user?.email}</span>
                    <button
                      onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
                      className="text-sm text-white bg-red-500 px-3 py-1 rounded"
                    >
                      Logout
                    </button>
                  </>
                ) : (
                  <button
                    onClick={() => loginWithRedirect()}
                    className="text-sm text-white bg-blue-600 px-3 py-1 rounded"
                  >
                    Login
                  </button>
                )}
              </div>
            </div>
          </div>
        </nav>

        {/* Main Content */}
        <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/callback" element={<Callback />} />
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/bias"
            element={
              <PrivateRoute>
                <BiasPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/bias/:id"
            element={
              <PrivateRoute>
                <BiasDetailPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/trends"
            element={
              <PrivateRoute>
                <TrendsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/trends/:id"
            element={
              <PrivateRoute>
                <TrendDetailPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/triggers"
            element={
              <PrivateRoute>
                <TriggersPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/triggers/:id"
            element={
              <PrivateRoute>
                <TriggerDetailPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/corner-to-corner"
            element={
              <PrivateRoute>
                <CornerToCornerPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/corner-to-corner/:id_ticker/:id_candlestick"
            element={
              <PrivateRoute>
                <CornerToCornerDetailPage />
              </PrivateRoute>
            }
          />
        </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;